'use strict';
const angular = require('angular');
import ShopsController from './shops.controller';
import routes from './shops.routes';
import shopCrud from './shopCrud';

export default angular.module('nomasvelloDashboardApp.shops', [
    shopCrud
])
    .config(routes)
    .controller('ShopsController', ShopsController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/shops/index.ts